import React from 'react'
import Reflux from 'reflux-react-16'

import LoginActions from '../actions/LoginActions.js'

import {H6} from '../../src/components/UI/index.js'
import {FormStack} from '../../src/components/UI/forms/index.js'
import {ScrollContainer, TopBar, Select} from '../components/UI/index.js'

import NavApps from '../utils/NavApps.js'

class Settings extends Reflux.Component {
    constructor(props) {
        super(props)

        this.state = {
            videoInputDevices: [],
            savedCameraDeviceId: localStorage.savedCameraDeviceId
        }
    }

    componentDidMount() {
        navigator.mediaDevices?.enumerateDevices().then((videoInputDevices) => {
            if (videoInputDevices) {
                videoInputDevices = videoInputDevices.filter((device) => device.kind === 'videoinput')
                this.setState({videoInputDevices})
            }
        })
    }

    onChangeValue(key, event) {
        const user = {...this.props.user}

        user.settings[key] = event.target.value

        if (key === 'navigationApp') {
            const transportTypes = NavApps[user.settings.navigationApp]?.transportTypes || []

            if (!transportTypes.some((type) => type.value === user.settings.transportType)) {
                user.settings.transportType = 'routeVehicle'
            }
        }

        LoginActions.updateUserSettings(user, (err) => {
            if (err) {
                alert(err)
            }
        })
    }

    onChangeSavedCameraDeviceid(event) {
        localStorage.savedCameraDeviceId = event.target.value
        this.setState({savedCameraDeviceId: event.target.value})
    }

    render() {
        const {videoInputDevices, savedCameraDeviceId} = this.state
        const {reseller, user, history, branding} = this.props

        const videoInputDevicesArray = [...videoInputDevices]
        videoInputDevicesArray.unshift({deviceId: '', label: 'Geen'})
        videoInputDevicesArray.push({deviceId: 'externalScanner', label: 'Externe scanner'})

        return (

            <>
                <TopBar reseller={reseller} user={user} history={history} showBack={true} showAccount={true} branding={branding} />

                <ScrollContainer>
                    <div style={{width: '90%', marginBottom: 12}}>
                        <H6 style={{marginBottom: 12, marginTop: 30}}>Navigatie</H6>
                        <FormStack>
                            <Select
                                closeButton
                                label='Navigatie app'
                                value={user.settings?.navigationApp || 'googleMaps'}
                                options={Object.values(NavApps).map((app) => {
                                    return {value: app.value, title: app.title}
                                })}
                                onChange={this.onChangeValue.bind(this, 'navigationApp')}
                            />

                            <Select
                                closeButton
                                label='Vervoersmiddel'
                                value={NavApps[user.settings?.navigationApp || 'googleMaps']?.transportTypes.some((type) => type.value === user.settings?.transportType) ? user.settings.transportType : 'routeVehicle'}
                                options={[
                                    {value: 'routeVehicle', title: 'Gebruik route voertuig'},
                                    ...NavApps[user.settings?.navigationApp || 'googleMaps']?.transportTypes.map((type) => {
                                        return {value: type.value, title: type.label}
                                    }) || []
                                ]}
                                onChange={this.onChangeValue.bind(this, 'transportType')}
                            />
                        </FormStack>

                    </div>

                    <div style={{width: '90%', marginBottom: 12}}>
                        <H6 style={{marginBottom: 12, marginTop: 30}}>Scannen</H6>
                        <Select
                            closeButton
                            label='Standaard camera voor scannen'
                            value={savedCameraDeviceId || localStorage.savedCameraDeviceId || ''}
                            options={videoInputDevicesArray.map((device) => {
                                return {value: device.deviceId, title: device.label}
                            })}
                            onChange={this.onChangeSavedCameraDeviceid.bind(this)}
                        />

                    </div>

                    <div style={{width: '90%', marginBottom: 12}}>
                        <H6 style={{marginBottom: 12, marginTop: 30}}>Algemeen</H6>
                        <Select
                            closeButton
                            label='Weergave adreslijst'
                            value={user.settings?.addressListStyle || 'compact'}
                            options={[
                                {value: 'compact', title: 'Compact'},
                                {value: 'extended', title: 'Uitgebreid'}
                            ]}
                            onChange={this.onChangeValue.bind(this, 'addressListStyle')}
                        />

                    </div>
                </ScrollContainer>
            </>
        )
    }
}

export default (Settings)
